export default __webpack_public_path__ + "static/media/movie.f03dd9b0.PNG";